<template>
    <div>
        <form class="form-horizontal">
            <div class="form-group">
                <label class="col-sm-1 control-label">DT INICIAL:</label>
                <div class="col-lg-2">
                    <input v-model="json.inicio" type="date" class="form-control">
                </div>
                <label class="col-sm-1 control-label">DT FINAL:</label>
                <div class="col-lg-2">
                    <input v-model="json.final" type="date" class="form-control">
                </div>
                <div class="col-lg-2">
                    <button type="button" @click="loadGrid()" class="btn btn-block btn-sm btn-success">BUSCAR</button>
                </div>
                <div class="col-4 text-right" >
                    <button @click="toPDF()" type="button" class="btn btn-sm btn-default" v-if="total">
                        <i class="fa fa-file-pdf-o"></i> GERAR PDF
                    </button>
                    <button @click="toExcel()" type="button" class="btn btn-sm btn-default" v-if="total">
                        <i class="fa fa-file-excel-o"></i> GERAR EXCELL
                    </button>
                </div>
            </div>
        </form>

        <div class="row">
            <div class="col-lg-12">
                <div id="gridboxRelatorioAlertas" style="position: relative; margin-top: -5px; bottom: 0; background-color:white;"></div>
                <div style="background-color: #2c3e50; padding: 5px; margin-top: 5px; margin-bottom: 5px; color: WHITE">
                    TOTAL DE REGISTROS: {{total}}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { ExportGrid } from "../../class/export-grid";
    import { RelatorioAlertas } from "../../class/relatorio-alertas";
    import { SET_ALERTAS } from "../../mutation-types";

    export default {
        name: 'RelatorioAlertas',

        props: {
            uuid: {
                default: null
            },
            height_difference : {
                type: Number,
                "default": 370
            }
        },

        data () {
            return {
                json: {
                    inicio: null,
                    final: null,
                    id_rastreador: null
                },
                mygrid: null,
                total: 0,
                timer: null,
                id: null
            }
        },

        beforeMount() {
            this.json.id_rastreador = this.id_rastreador;
            let data = new Date();

            this.json.inicio = data.getFullYear() + "-" + (data.getMonth() + 1).toString().padStart(2, '0') + "-" + data.getDate().toString().padStart(2, '0');
            this.json.final = data.getFullYear() + "-" + (data.getMonth() + 1).toString().padStart(2, '0') + "-" + data.getDate().toString().padStart(2, '0');
        },

        beforeDestroy() {
            this.mygrid = null;
        },

        mounted(){
            setTimeout(() => this.load(), 1000);
        },

        methods: {

            load () {
                this.mygrid = new dhtmlXGridObject('gridboxRelatorioAlertas');

                this.mygrid.setHeader("PLACA,USUÁRIO,RESOLVIDO,DATA ALERTA,DATA FECHAMENTO,TÍTULO");
                this.mygrid.setInitWidths("130,130,130,130,130,*");
                this.mygrid.setColAlign("center,center,center,center,center,left");
                this.mygrid.setColTypes("ro,ro,ro,ro,ro,ro");
                this.mygrid.attachHeader("#text_filter,#text_filter,#select_filter,#text_filter,#text_filter,#text_filter");
                this.mygrid.setColSorting("str,str,str,datetimeSort,datetimeSort,str");
                this.mygrid.setSkin("dhx_web");
                this.mygrid.attachEvent("onRowDblClicked", () => this.edit());
                this.mygrid.attachEvent("onFilterEnd", () => this.countRow());

                this.mygrid.init();

                let res = () => {
                    $('#gridboxRelatorioAlertas').height( $(window).height() - this.height_difference );
                };

                res();
                window.onresize = res;
            },

            edit () {
                let id = this.mygrid.getSelectedId();
                this.add(id);
            },

            add (id) {
                this.$store.commit(SET_ALERTAS, id);
            },

            toPDF(){
                ExportGrid.pdf(this.mygrid);
            },

            toExcel(){
                ExportGrid.excel(this.mygrid);
            },

            countRow(){
                this.total = this.mygrid.getRowsNum();
            },

            async loadGrid(){

                RelatorioAlertas.grid(this.uuid, this.json).then((data) => {
                    this.mygrid.clearAll();
                    this.mygrid.parse(data, () => {
                        this.countRow();
                        this.mygrid.filterByAll();
                    }, 'json');
                })
                    .catch((err) => {
                        console.log(err);
                    });

            }
        }
    };
</script>

<style scoped>

</style>
